import { render, staticRenderFns } from "./BindGoodsHeader.vue?vue&type=template&id=2198414a&scoped=true&"
import script from "./BindGoodsHeader.vue?vue&type=script&lang=ts&"
export * from "./BindGoodsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BindGoodsHeader.vue?vue&type=style&index=0&id=2198414a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2198414a",
  null
  
)

export default component.exports